import { render } from "./Liquid.vue?vue&type=template&id=1cde278f"
import script from "./Liquid.vue?vue&type=script&lang=js"
export * from "./Liquid.vue?vue&type=script&lang=js"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__